import styled from '@emotion/styled'

export const StyleGrid = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(8, 1fr);
  @media (max-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const StyleGridItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: center;
  position: relative;
`

export const StyleCheckedIconWrapper = styled.div`
  position: absolute;
  top: -3px;
  right: -9px;
`

export const StyleSearchWrapper = styled.div`
  position: relative;
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  height: 40px;
  border-radius: 4px;
  width: 50%;
  margin-bottom: 30px;
  padding: 0px 5px;
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    width: 70%;
  }
  @media (max-width: 640px) {
    width: 100%;
  }
`

export const StyleSearchInput = styled.input<any>`
  outline: none;
  border: 0px;
  height: 40px;
  padding: 0px;
  background: transparent;
  flex: 1;
  text-indent: 5px;
  font-size: 14px;
  &::placeholder {
    color: ${(props: any) => props.theme.colors.inputBorder};
    font-size: 14px;
  }
`
